/*
  Responsive content tables (guide pages: Lumber Forks, What Class, Capacity Chart, Standard vs Full Taper, How to Measure).
  Dawn has no responsive table, and these tables live in page bodies (rte), so this is a small progressive enhancement:
  - tables that can't read well as a table on a phone (5+ columns or sentence-length cells) get .nlf-stack;
    every body cell gets data-label = its column header, so CSS can stack each row as a card on phones
    (no horizontal page scroll, no 4-line cells);
  - short values ("Class 3", '10" × 1.75"', "9,600 lb") get .nlf-nowrap so they don't break mid-value on desktop.
  Without JS the tables render exactly as before.
*/
(function () {
  function enhance(table) {
    if (table.dataset.nlfStack || !table.tHead) return;
    var heads = Array.prototype.map.call(table.tHead.rows[0].cells, function (c) {
      var t = c.textContent.trim();
      if (t.length <= 20) c.classList.add('nlf-nowrap'); // short headers stay on one line; long ones may wrap
      return t;
    });
    Array.prototype.forEach.call(table.tBodies, function (tbody) {
      Array.prototype.forEach.call(tbody.rows, function (row) {
        Array.prototype.forEach.call(row.cells, function (cell, i) {
          if (heads[i]) cell.setAttribute('data-label', heads[i]);
          if (cell.textContent.trim().length <= 20) cell.classList.add('nlf-nowrap');
        });
      });
    });
    table.dataset.nlfStack = '1';
    // Card layout only where a plain table reads badly on a phone: too wide to fit, or sentence-length cells
    // (which would wrap to 4+ lines in a narrow column). Short-value tables like the capacity chart stay tables.
    var long = Array.prototype.some.call(table.querySelectorAll('td'), function (c) {
      return c.textContent.trim().length > 30;
    });
    if (long || table.tHead.rows[0].cells.length >= 5) table.classList.add('nlf-stack');
    else table.classList.add('nlf-fit');
  }
  function run() {
    document.querySelectorAll('.rte table').forEach(enhance);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
